import Lottie from "lottie-react";
import notfound from "../../assets/404.json";
import empty from "../../assets/empty.json";
import load from "../../assets/loading.json";
import React from "react";

export const NotFound = ({loading, isEmptyList}) => {

    return (
        <div className="container">
            <div style={{maxWidth: loading ? "250px" : "700px", margin: "auto"}}>
                <Lottie animationData={loading ? load : isEmptyList ? empty : notfound} loop={true}/>
            </div>
        </div>
    );

}
